











































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import moment from "moment/moment";
@Component({})
export default class MessageDetail extends Vue {
  @Prop()
  selectedEmail;
  @Prop()
  isOpen: boolean;

  formatDate (date: Date) {
    return moment(date).format("MM/DD/yyyy hh:mm A");
  }
  closeEmail () {
    this.$emit("onDetailClose");
  }
}
